import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';

import { BetslipType } from '../../../core/betslip-type';
import { GroupPickId } from '../../../core/picks/pick-id';
import { ensureTabbedMode } from '../../linear/helpers';
import { BetslipTypesActions } from '../../types/actions';
import { betslipTypeStateSelector } from '../../types/selectors';
import { QuickBetActions } from '../quick-bet-actions';
import { quickBetStateSelector } from '../quick-bet.selectors';

@Injectable()
export class QuickBetGroupPickEffects {
    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}

    handleAddingGroupPickToQuickBet$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(QuickBetActions.addPick),
            filter((action) => GroupPickId.isId(action.pickId)),
            concatLatestFrom(() => this.store.select(betslipTypeStateSelector)),
            filter(([_, typeState]) => typeState.base.currentSelectedType !== BetslipType.Combo || !typeState.base.selectedByUser),
            map(() => {
                return BetslipTypesActions.setOriginalBase();
            }),
        );
    });

    handleTypeChangeAddingGroupPickToQuickBet$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(QuickBetActions.addPick),
            ensureTabbedMode(this.store),
            filter((action) => GroupPickId.isId(action.pickId)),
            concatLatestFrom(() => [this.store.select(betslipTypeStateSelector), this.store.select(quickBetStateSelector)]),
            filter(
                ([_, typeState, quickBet]) =>
                    (typeState.base.currentSelectedType !== BetslipType.Combo || !typeState.base.selectedByUser) && quickBet.inOverlay,
            ),
            map(() => {
                return BetslipTypesActions.setSelectedType({ betslipType: BetslipType.Combo, selectedByUser: true, systemInfo: null });
            }),
        );
    });
}
